export enum IdinStatusEnum {
  SUCCESS = 'Success',
  CANCELLED = 'Cancelled',
  FAILURE = 'Failure',
  EXPIRED = 'Expired',
  OPEN = 'Open',
}
